'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.maybeBoldSpan = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.transform = transform;
exports.contains = contains;
exports.findIndex = findIndex;
exports.find = find;
exports.throttle = throttle;
exports.createChainedFunction = createChainedFunction;

var _PropTypes = require('./PropTypes');

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Text = require('../Text');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var maybeBoldSpan = function maybeBoldSpan(bold) {
  function MaybeBoldSpan(_ref) {
    var spanRef = _ref.spanRef,
        props = _objectWithoutProperties(_ref, ['spanRef']);

    var Span = bold ? _Text.Body2 : _Text.Body1;
    return _react2['default'].createElement(Span, _extends({ component: 'span', componentRef: spanRef }, props));
  }
  MaybeBoldSpan.propTypes = {
    spanRef: _PropTypes2['default'].func
  };
  MaybeBoldSpan.defaultProps = {
    spanRef: function () {
      function spanRef() {}

      return spanRef;
    }()
  };
  MaybeBoldSpan.displayName = 'MaybeBoldSpan';
  return MaybeBoldSpan;
};

exports.maybeBoldSpan = maybeBoldSpan;
function transform(obj, cb, accumulator) {
  Object.keys(obj).forEach(function (key) {
    cb(accumulator, obj[key], key);
  });
  return accumulator;
}

function contains(obj, pred) {
  return Object.keys(pred).every(function (key) {
    return obj.hasOwnProperty(key) && obj[key] === pred[key];
  });
}

function findIndex(arr, pred) {
  var predType = typeof pred === 'undefined' ? 'undefined' : _typeof(pred);
  for (var i = 0; i < arr.length; i += 1) {
    if (predType === 'function' && !!pred(arr[i], i, arr) === true) {
      return i;
    }
    if (predType === 'object' && contains(arr[i], pred)) {
      return i;
    }
    if (['string', 'number', 'boolean'].indexOf(predType) !== -1) {
      return arr.indexOf(pred);
    }
  }
  return -1;
}

function find(arr, pred) {
  var index = findIndex(arr, pred);
  return index > -1 ? arr[index] : undefined;
}

function throttle(fn, limit) {
  var wait = false;
  return function () {
    function throttledFn() {
      if (!wait) {
        fn.call();
        wait = true;
        return setTimeout(function () {
          wait = false;
        }, limit);
      }
      return null;
    }

    return throttledFn;
  }();
}

/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */
function createChainedFunction() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.filter(function (f) {
    return f != null;
  }).reduce(function (acc, f) {
    if (typeof f !== 'function') {
      throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
    }

    if (acc === null) {
      return f;
    }

    return function () {
      function chainedFunction() {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        acc.apply(this, args);
        f.apply(this, args);
      }

      return chainedFunction;
    }();
  }, null);
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/utils/helpers.js
// module id = 735
// module chunks = 32